export const witnessId = process.env.REACT_APP_KYC_WITNESSID
    ? parseInt(process.env.REACT_APP_KYC_WITNESSID)
    : undefined
export const platformCurrencyISO = process.env.REACT_APP_CURRENCY
